// --- Price Discount Feature ---
function initValentineDiscount() {
  const DISCOUNT_PERCENT = 20;
  const currencySymbol = window.currencySymbol || '$';

  function formatMoney(cents) {
    const amount = cents / 100;
    const formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return currencySymbol + ' ' + formatted;
  }

  function updateDiscountUI(variantPrice) {
    const saveEl = document.querySelector('.js-save-amount');
    const priceContainer = document.querySelector('.price');
    if (!priceContainer || !saveEl) return;

    const baseDisplayedPrice = variantPrice * 0.8;
    const saveCents = Math.round(baseDisplayedPrice * DISCOUNT_PERCENT / 100);
    saveEl.innerText = formatMoney(saveCents);

    // Store the raw variant price on the container for later calculations
    priceContainer.dataset.rawPriceCents = variantPrice;
  }

  // Initial load
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput && variantInput.value) {
    fetch(`/variants/${variantInput.value}.js`)
      .then(r => r.json())
      .then(v => {
        if (v && v.price) {
          updateDiscountUI(v.price);
        }
      });
  }

  // Subscribe to variant changes
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data.variant;
      if (variant && variant.price) {
        updateDiscountUI(variant.price);
        // Reset checkbox
        const checkbox = document.querySelector('.save-checkbox input');
        if (checkbox) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  // Checkbox toggle display logic
  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('.save-checkbox input');
    if (!checkbox) return;

    const priceContainer = document.querySelector('.price');
    if (!priceContainer) return;

    // The main price element that changes (either sale price or regular price)
    const isOnSale = priceContainer.classList.contains('price--on-sale');
    const activePriceEl = isOnSale
      ? priceContainer.querySelector('.price__sale .price-item--sale')
      : priceContainer.querySelector('.price__regular .price-item--regular');

    if (!activePriceEl) return;

    if (checkbox.checked) {
      // Save original text
      if (!activePriceEl.dataset.originalText) {
        activePriceEl.dataset.originalText = activePriceEl.innerText;
      }

      const rawPrice = parseInt(priceContainer.dataset.rawPriceCents);
      if (rawPrice) {
        const discountedCents = Math.round(rawPrice * 0.64);
        activePriceEl.innerText = formatMoney(discountedCents);
      }
    } else {
      // Restore original text
      if (activePriceEl.dataset.originalText) {
        activePriceEl.innerText = activePriceEl.dataset.originalText;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initValentineDiscount);
// review model open in product page 
document.addEventListener('DOMContentLoaded', function () {

  const modal = document.getElementById('review-modal');
  const openBtn = document.querySelector('.review-open-btn');

  if (!modal) return;

  const closeBtn = modal.querySelector('.review-close');
  const overlay = modal.querySelector('.review-overlay');

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.review-open-btn');
    if (btn) {
      modal.classList.add('active');
      document.body.classList.add('modal-open');
    }
  });

  function closeModal() {
    modal.classList.remove('active');
    document.body.classList.remove('modal-open');
  }

  closeBtn?.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal || e.target === overlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

});

document.addEventListener('change', function (e) {
  const dropdown = e.target.closest('.ring-size-dropdown');
  if (!dropdown) return;

  const value = dropdown.value.toLowerCase();

  const swatch = document.querySelector(
    `.bls__option-swatch-js[data-value="${value}"]`
  );

  if (swatch) {
    swatch.click();
  }

  console.log("document.querySelectorAll('.bls__option-swatch-js').length", document.querySelectorAll('.bls__option-swatch-js').length);

});


(function initProductStickyTop() {
  // Only run on product pages
  if (!document.querySelector('.product__media-wrapper')) return;

  function updateStickyTop() {
    // Measure all position:sticky / position:fixed elements at the top of the page
    let topOffset = 0;
    const header = document.querySelector('.section-header');
    const announcementBar = document.querySelector('.announcement-bar-section, .shopify-section-header-sticky, [class*="announcement"]');
    if (header) {
      const rect = header.getBoundingClientRect();
      // If the header is sticky/fixed, its bottom value = height from viewport top
      topOffset = Math.max(topOffset, rect.bottom);
    }
    if (announcementBar && !header) {
      const rect = announcementBar.getBoundingClientRect();
      topOffset = Math.max(topOffset, rect.bottom);
    }
    document.documentElement.style.setProperty('--product-sticky-top', topOffset + 'px');
  }

  document.addEventListener('DOMContentLoaded', updateStickyTop);
  window.addEventListener('load', updateStickyTop);
  window.addEventListener('resize', updateStickyTop);
})();

// product page video infinite loop 
(function () {
  function forceHideVideoUI() {
    document.querySelectorAll('deferred-media').forEach(media => {
      if (!media.getAttribute('loaded')) {
        const template = media.querySelector('template');
        if (template) {
          const content = template.content.firstElementChild.cloneNode(true);
          media.setAttribute('loaded', true);
          const deferredElement = media.appendChild(content);

          if (deferredElement.nodeName === 'VIDEO') {
            deferredElement.muted = true;
            deferredElement.setAttribute('muted', '');
            deferredElement.play().catch(() => { });
          } else if (deferredElement.nodeName === 'IFRAME') {
            // Handle YouTube/Vimeo autoplay by ensuring mute parameter is present
            let src = deferredElement.getAttribute('src');
            if (src && !src.includes('mute=') && !src.includes('muted=')) {
              src += (src.includes('?') ? '&' : '?') + (src.includes('youtube.com') ? 'mute=1' : 'muted=1');
              deferredElement.setAttribute('src', src);
            }
          }
        }
      }
    });

    const allVideos = document.querySelectorAll('video');
    allVideos.forEach(video => {
      video.classList.add('js-autoplay-infinite');
      video.controls = false;
      video.removeAttribute('controls');

      video.muted = true;
      video.setAttribute('muted', '');
      video.loop = true;
      video.setAttribute('autoplay', 'autoplay');
      video.setAttribute('playsinline', 'true');

      video.style.pointerEvents = 'none';

      const container = video.closest('.deferred-media, .product__media');
      if (container) {
        const customControls = container.querySelectorAll('.shopify-video-controls, .shopify-video-ui, .deferred-media__poster-button, .product__media-toggle');
        customControls.forEach(el => el.remove());
      }

      if (video.paused) {
        video.play().catch(() => { });
      }
    });
  }

  const observer = new MutationObserver(forceHideVideoUI);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('load', forceHideVideoUI);
  forceHideVideoUI();
})();

function reorderProductGallery() {
  const isWeddingProduct = document.querySelector('[data-is-wedding-band="true"]') || document.title.toLowerCase().includes('wedding') || document.title.toLowerCase().includes('band');
  if (isWeddingProduct) return;
  const selectedVariantInput = document.querySelector('.product-form__input input:checked + label') ||
    document.querySelector('.product-form__input select option:checked');
  const selectedVariant = selectedVariantInput?.innerText?.toLowerCase() || selectedVariantInput?.value?.toLowerCase() || "";
  const container = document.querySelector('.product__media-list');
  const mediaItems = Array.from(document.querySelectorAll('.product__media-item'));

  if (!container || mediaItems.length === 0) return;

  let matchingVideo = null;
  const matchingImages = [];
  const otherMetalImages = [];
  const generalImages = [];

  mediaItems.forEach((item) => {
    const isVideo = !!item.querySelector('video, deferred-media, iframe');
    const img = item.querySelector('img');
    const altText = (img?.getAttribute('alt') || '').toLowerCase();

    // Identify metal associations for the media
    const mediaIsYellow = altText.includes('yellow') || altText.includes('yg');
    const mediaIsRose = altText.includes('rose') || altText.includes('pink') || altText.includes('rg');
    const mediaIsWhite = altText.includes('white') || altText.includes('silver') || altText.includes('platinum') || altText.includes('pt') || altText.includes('sterling') || altText.includes('wg');

    // Identify metal associations for the variant
    const variantIsYellow = selectedVariant.includes('yellow') || selectedVariant.includes('yg');
    const variantIsRose = selectedVariant.includes('rose') || selectedVariant.includes('pink') || selectedVariant.includes('rg');
    const variantIsWhite = selectedVariant.includes('white') || selectedVariant.includes('silver') || selectedVariant.includes('platinum') || selectedVariant.includes('pt') || selectedVariant.includes('sterling') || selectedVariant.includes('wg');

    const isCurrentMatch = (variantIsYellow && mediaIsYellow) || (variantIsRose && mediaIsRose) || (variantIsWhite && mediaIsWhite) || altText === 'all';

    if (isVideo) {
      if (isCurrentMatch) {
        if (!matchingVideo) {
          matchingVideo = item;
          item.style.display = ''; // Show
        } else {
          generalImages.push(item);
          item.style.display = ''; // Show
        }
      } else if (mediaIsYellow || mediaIsRose || mediaIsWhite) {
        // Video for OTHER metal - HIDE IT
        item.style.display = 'none';
      } else {
        // General video - show and use as fallback if needed
        item.style.display = '';
        if (!matchingVideo) {
          matchingVideo = item;
        } else {
          generalImages.push(item);
        }
      }
    } else {
      // It's an image
      if (isCurrentMatch) {
        matchingImages.push(item);
        item.style.display = '';
      } else if (mediaIsYellow || mediaIsRose || mediaIsWhite) {
        otherMetalImages.push(item);
        item.style.display = '';
      } else {
        generalImages.push(item);
        item.style.display = '';
      }
    }
  });

  const firstImage = matchingImages[0] || (mediaItems.find(item => !item.querySelector('video, deferred-media, iframe')));

  const finalOrder = [];
  if (firstImage) finalOrder.push(firstImage);
  if (matchingVideo && matchingVideo !== firstImage) finalOrder.push(matchingVideo);

  matchingImages.forEach(img => {
    if (img !== firstImage && img !== matchingVideo) finalOrder.push(img);
  });
  otherMetalImages.forEach(img => {
    if (img !== firstImage && img !== matchingVideo) finalOrder.push(img);
  });
  generalImages.forEach(img => {
    if (img !== firstImage && img !== matchingVideo) finalOrder.push(img);
  });

  // Gallery refresh logic - optimized to avoid flickering (no innerHTML = '')
  finalOrder.forEach(item => {
    if (item.parentNode === container) {
      container.appendChild(item); // appendChild on existing nodes just moves them
    }
  });

  // Reset view to top
  const slider = document.querySelector('slider-component');
  if (slider) {
    container.scrollTo({ left: 0, behavior: 'instant' });
  }
}

document.addEventListener('change', function (event) {
  const variantInput = event.target.closest('.product-form__input input[type="radio"], .product-form__input select');
  if (variantInput) {
    setTimeout(reorderProductGallery, 0);
  }
});

// Run on page load and refresh (safety net, Liquid handles initial)
window.addEventListener('load', () => setTimeout(reorderProductGallery, 0));
document.addEventListener('DOMContentLoaded', () => setTimeout(reorderProductGallery, 0));

// Pify Ring Size Chart script
window.originalPifyBtn = null;
window.safePifyClone = null;

setInterval(function () {
  const el = document.querySelector('optis-option-watermark');
  if (el) el.remove();

  const ringSizeWrapper = document.querySelector('.ring-size-selector-wrapper');
  if (!ringSizeWrapper) return;

  // Look for the real Pify button (not our clone)
  const realPifyBtn = document.querySelector(".pify_inline_button:not([data-is-clone='true'])");

  if (realPifyBtn) {
    // We found a real Pify button (either the first one or a newly injected one)
    window.originalPifyBtn = realPifyBtn;

    // Ensure we have a working clone ready
    if (!window.safePifyClone) {
      window.safePifyClone = realPifyBtn.cloneNode(true);
      window.safePifyClone.dataset.isClone = 'true';

      // Forward clicks to the real button so the modal still opens
      window.safePifyClone.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (window.originalPifyBtn) {
          window.originalPifyBtn.click();
        }
      });
    }

    // Move the real button into position
    if (realPifyBtn.parentElement !== ringSizeWrapper) {
      ringSizeWrapper.appendChild(realPifyBtn);
    }

    // If our clone was previously inserted, remove it because we have the real one
    if (window.safePifyClone && window.safePifyClone.parentElement) {
      window.safePifyClone.remove();
    }
  } else {
    // The real Pify button is missing! (Pify destroyed it)
    // Restore our proxy clone so the UI stays intact and clicks are forwarded
    if (window.safePifyClone && window.safePifyClone.parentElement !== ringSizeWrapper) {
      ringSizeWrapper.appendChild(window.safePifyClone);
    }
  }
}, 100);
